import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import { PoweredByQITech } from '../components/PoweredByQITech';
import * as S from './styles';

export const BaseCanceledPage = () => {
    const { clientThemeSettings } = useThemeContext();

    if (!clientThemeSettings) return <></>;

    const primary = resolveColor('primary', clientThemeSettings);

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {clientThemeSettings.logo_url && (
                    <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                )}
            </S.LogoSection>

            <S.Content>
                <S.IconWrapper $color={primary}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="6" y1="6" x2="18" y2="18" />
                        <line x1="18" y1="6" x2="6" y2="18" />
                    </svg>
                </S.IconWrapper>
                <S.Title $color={primary}>Assinatura cancelada</S.Title>
                <S.Subtitle>
                    Este processo de assinatura foi cancelado e não está mais disponível. Em caso de dúvidas, entre em contato com o responsável pelo envio dos documentos.
                </S.Subtitle>
            </S.Content>

            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
